import { ActionTypes } from '../constants/actionTypes.js';
import { api } from "../apis/ComponentApis.js";
import { queryClient } from '../query/queryClient.js';

// open and close Add a colleague drawer action creators
export const modalOpenActions = (active) => ({
    type: ActionTypes.SET_ADD_COLLEAGUE_DRAWER_OPEN,
    payload: active
});

export const editModalOpenActions = (active) => ({
    type: ActionTypes.SET_EDIT_COLLEAGUE_DRAWER_OPEN,
    payload: active
});


export const setIsEdit = (active) => ({
    type: ActionTypes.SET_IS_EDIT,
    payload: active
});

export const resetIsEdit = (active) => ({
    type: ActionTypes.RESET_IS_EDIT,
    payload: active
});

export const setConfimationAlert = (active) => ({
    type: ActionTypes.SET_CONFIRMATION_ALERT,
    payload: active
});

export const ConfimationAction = (active) => ({
    type: ActionTypes.SET_CONFIRMATION_ACTION,
    payload: active
});

export const resetConfimationAction = (active) => ({
    type: ActionTypes.RESET_CONFIRMATION_ACTION,
    payload: active
});

export const setColleagueFormData = (field, value) => ({
    type: ActionTypes.SET_COLLEAGUE_FORMDATA,
    payload: { field, value }
});

export const resetColleagueFormData = () => ({
    type: ActionTypes.RESET_COLLEAGUE_FORMDATA,
});

export const setFormEntries = (value) => ({
    type: ActionTypes.SET_EDITFORM_DEFAULT_ENTRIES,
    payload: value
});

export const resetFormEntries = () => ({
    type: ActionTypes.RESET_EDITFORM_DEFAULT_ENTRIES,
});

export const setFormFieldErrors = (field, value) => ({
    type: ActionTypes.SET_FORMFIELD_ERRORS,
    payload: { field, value }
});

export const resetFormFieldErrors = () => ({
    type: ActionTypes.RESET_FORMFIELD_ERRORS,
});

export const closeStatusToastMessage = () => ({
    type: ActionTypes.CLOSE_STATUS_TOASTMESSAGE,
    payload: { open: false, message: "", status: "" }
});

export const setUserDetailsParameters = (parameters) => ({
    type: ActionTypes.SET_USER_DETAILS_PARAMETERS,
    payload: parameters
});

export const toggleUserActiveStatus = (params) => async (dispatch, getState) => {
    dispatch({
        type: ActionTypes.UPDATE_COLLEAGUE_REQUEST,
        payload: { open: true, message: "Updating status...Please wait.", status: "loading" }
    });
    try {
        const url = '/api/UpdateUserSite';
        const response = await api.put(url, params);
        if (response.data.code === 200) {
            dispatch({
                type: ActionTypes.POST_ADD_COLLEAGUE_SUCCESS,
            })
            dispatch({
                type: ActionTypes.STATUS_TOASTMESSAGE,
                payload: { open: true, message: "User Updated successfully!", status: "success" }
            });
           
                await queryClient.invalidateQueries({ queryKey: ['mrt', 'userManagement'], exact: false });     
        }
    } catch (error) {
        dispatch({
            type: ActionTypes.POST_ADD_COLLEAGUE_FAILURE,
            payload: error
        })
    }
}

export const addColleagueAPIRequest = (params) => async (dispatch, getState) => {
    dispatch({
        type: ActionTypes.ADD_COLLEAGUE_REQUEST,
        payload: { open: true, message: "Adding colleague...Please wait.", status: "loading" }
    });
    try {
        const url = `/api/User`;
        const response = await api.post(url, params);
        dispatch({
            type: ActionTypes.POST_ADD_COLLEAGUE_SUCCESS,
        })
        if (response.data.code === 200) {
            dispatch({
                type: ActionTypes.STATUS_TOASTMESSAGE,
                payload: { open: true, message: "User added successfully!", status: "success" }
            });
            await queryClient.invalidateQueries({ queryKey: ['mrt', 'userManagement'], exact: false });
        } else if (response.data.code === 5001) {
            dispatch({
                type: ActionTypes.STATUS_TOASTMESSAGE,
                payload: { open: true, message: "User already exists!", status: "alert" }
            });
        }
    } catch (error) {
        console.log(error);
        dispatch({
            type: ActionTypes.POST_ADD_COLLEAGUE_FAILURE,
            payload: error
        })
    }
};

export const updateColleagueAPIRequest = (params) => async (dispatch, getState) => {
    dispatch({
        type: ActionTypes.UPDATE_COLLEAGUE_REQUEST,
        payload: { open: true, message: "Updating details...Please wait.", status: "loading" }
    });
    try {
        const url = `/api/UpdateUser`;
        const response = await api.put(url, params);
        dispatch({
            type: ActionTypes.POST_ADD_COLLEAGUE_SUCCESS,
        })
        if (response.data.code === 200) {
            dispatch({
                type: ActionTypes.STATUS_TOASTMESSAGE,
                payload: { open: true, message: "User updated successfully!", status: "success" }
            });await queryClient.invalidateQueries({ queryKey: ['mrt', 'userManagement'], exact: false });
        } else if (response.data.code === 5001) {
            dispatch({
                type: ActionTypes.STATUS_TOASTMESSAGE,
                payload: { open: true, message: "User already exists!", status: "alert" }
            });
        }
    } catch (error) {
        console.log(error);
        dispatch({
            type: ActionTypes.POST_ADD_COLLEAGUE_FAILURE,
            payload: error
        })
    }
};
